'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function getNsParamValue(url) {
  var results = RegExp('[\\?&]ns=([^&#]*)').exec(url);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

exports.default = {
  load: function load(src) {
    src = src || 'https://api-maps.yandex.ru/2.1/?lang=en_RU';
    this.promise = this.promise || new Promise(function (resolve, reject) {
      var elem = document.createElement('script');
      elem.type = 'text/javascript';
      elem.src = src;
      elem.onload = resolve;
      elem.onerror = function (e) {
        return reject(e);
      };
      document.body.appendChild(elem);
    }).then(function () {
      var ns = getNsParamValue(src);
      if (ns && ns !== 'ymaps') {
        (1, eval)('var ymaps = ' + ns + ';');
      }
      return new Promise(function (resolve) {
        if (!global.ymaps) {
          throw new Error('Failed to find ymaps in the global scope');
        }
        if (!global.ymaps.ready) {
          throw new Error('ymaps.ready is missing');
        }
        return ymaps.ready(resolve);
      });
    });
    return this.promise;
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/ymaps/dist/ymaps.js
// module id = 359
// module chunks = 0